import { motion } from 'framer-motion';

const stats = [
  { value: '200+', label: 'Events Delivered', suffix: '' },
  { value: '50+', label: 'Corporate Clients', suffix: '' },
  { value: '15+', label: 'Cities Covered', suffix: '' },
  { value: '15+', label: 'Years of Excellence', suffix: '' },
];

export const StatsSection = () => {
  return (
    <section className="py-20 lg:py-24 bg-navy relative overflow-hidden grain" data-testid="stats-section">
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/4 w-64 h-64 bg-gold/10 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-white/5 rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {stats.map((stat, index) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="stat-item text-center lg:text-left"
              data-testid={`stat-${index}`}
            >
              <div className="font-heading text-4xl md:text-5xl lg:text-6xl text-gold mb-2">
                {stat.value}
              </div>
              <div className="text-white/70 text-sm md:text-base uppercase tracking-wider">
                {stat.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
